import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {interval, Subject} from 'rxjs';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  accessToken: string = null;

  login = new Subject<boolean>();

  logout = new Subject<boolean>();

  constructor(
    private httpClient: HttpClient,
    private router: Router
  ) {}

  public initAccessTokenSession() {

    // check session every minute
    const timerSubscription = interval(60000)
      .subscribe((val) => {
        console.log('session check');

        this.httpClient
          .get<any>('/ais/rest/apps/check-session/check-light', {observe: 'response'})
          .subscribe((res) => {
              if (res.headers.get('aisAuth')) {
                this.login.next(true);
                this.updateAccessToken(res.headers.get('aisAuth'));
              }
            },
            (error) => {
              console.error(error);
              if (error.status === 401) {
                window.location.href = '/ais/logout.do';
              }
            }
          );

      });

    this.retrieveAccessToken();
  }

  retrieveAccessToken() {

    const req = new XMLHttpRequest();
    req.open('POST', '/ais/rest/apps/get-access-token', false);
    req.setRequestHeader('B5nd8BgAoX', '2llVM1Fl3M');
    req.send();

    this.accessToken = req.getResponseHeader('AISAuth');

    if (this.accessToken === null) {
      this.logout.next(true);
      this.router.navigate(['/auth-error']).then(r => {});
    }
  }

  updateAccessToken(aisAuth: string) {
    this.accessToken = aisAuth;
  }
}
